import { default as React } from 'react';
import { makeStyles } from '@material-ui/core';
import { ErrorPanel } from '@backstage/core-components';

const useStyles = makeStyles(theme => ({
  errorContainer: {
    marginBottom: theme.spacing(2),
  },
}));

type ErrorDisplayProps = {
  error: Error | null;
  title?: string;
};

export const ErrorDisplay: React.FC<ErrorDisplayProps> = ({
  error,
  title = "Problemas ao carregar métricas",
}) => {
  const classes = useStyles();

  if (!error) return null;

  return (
    <div className={classes.errorContainer}>
      <ErrorPanel 
        error={error}
        title={title}
      />
    </div>
  );
};